import React, {Component} from 'react';
import { connect } from 'react-redux';
import {checkContainer } from '../general-functions';
import '../global';


class ProgressBox extends Component{

	render(){

		let current = '';
		if(checkContainer(this.props.name, this.props.currentPage )){
			current = 'current';
		}
		let stepStyle = {};
		if(getPasswordSkip() === 'true'){
			stepStyle = {
				width:'50%',
			};
		}
		if(typeof this.props.none !== 'undefined'){
			stepStyle = {
				display:'none'
			}
			return(
				<div style={stepStyle} className={`proto-ind-step ${current}`}>
					<h3 class="proto-ind-step-title">{this.props.title}</h3>
					<p class="proto-ind-step-desc">{this.props.description}</p>
				</div>
			);
		} else{
			return(
				<div style={stepStyle} className={`proto-ind-step ${current}`}>
					<h3 class="proto-ind-step-title">{this.props.title}</h3>
					<p class="proto-ind-step-desc">{this.props.description}</p>
				</div>
			);

		}


	}



}



function mapStateToProps( { currentPage, myCommittees, requestedCommittees } ) {
	return {
		currentPage, myCommittees, requestedCommittees
	};
}

export default connect (mapStateToProps, {checkContainer})(ProgressBox);